export var DEFAULT_TOP_20 = 'Top 20 Brands';
export var DEFAULT_ALL_CATEGORIES = 'All categories';
export var getFiltersConfiguration = function (configuration) {
    var seasonsChoices = configuration.data.season.map(function (row) {
        return {
            value: row.name,
            displayName: row.name,
        };
    });
    var defaultSeason = configuration.data.season.find(function (season) {
        return season.value === configuration.map.default_season;
    });
    var firstSeason = configuration.data.season[0];
    var categoryChoices = [{
            value: DEFAULT_ALL_CATEGORIES,
            displayName: DEFAULT_ALL_CATEGORIES,
        }];
    for (var _i = 0, _a = configuration.data.category; _i < _a.length; _i++) {
        var row = _a[_i];
        categoryChoices.push({
            value: row.name,
            displayName: row.name,
        });
    }
    var cityChoices = [{
            value: 'All cities',
            displayName: 'All cities'
        }];
    for (var _b = 0, _c = configuration.data.city; _b < _c.length; _b++) {
        var city = _c[_b];
        cityChoices.push({
            value: city.value,
            displayName: city.name,
        });
    }
    var typeChoices = configuration.data.type.map(function (row) {
        return {
            value: row.name,
            displayName: row.name,
        };
    });
    var defaultType = configuration.data.type.find(function (type) {
        return type.value === configuration.map.default_type;
    });
    return {
        defaultSeason: defaultSeason ? defaultSeason.name : firstSeason.value,
        defaultType: defaultType ? defaultType.name : 'Womenswear',
        defaultCity: 'All cities',
        seasonsChoices: seasonsChoices,
        categoryChoices: categoryChoices,
        cityChoices: cityChoices,
        typeChoices: typeChoices,
    };
};
export var seasonShortNames = [];
for (var i = 25; i >= 20; i--) {
    seasonShortNames.push({
        name: "Fall-Winter 20" + i,
        shortName: "FW" + i
    });
    seasonShortNames.push({
        name: "Pre-Fall 20" + i,
        shortName: "PF" + i
    });
    seasonShortNames.push({
        name: "Spring-Summer 20" + i,
        shortName: "SS" + i
    });
    seasonShortNames.push({
        name: "Resort 20" + i,
        shortName: "RS" + i
    });
}
export var jobChoices = [
    { value: 'All jobs', displayName: 'All jobs' },
    { value: 'PR communications', displayName: 'PR communications' },
    { value: 'Insights marketing', displayName: 'Insights marketing' },
    { value: 'Consumer', displayName: 'Consumer' },
    { value: 'Designer', displayName: 'Designer' },
    { value: 'Student', displayName: 'Student' },
    { value: 'Other', displayName: 'Other' },
    { value: 'Buyer', displayName: 'Buyer' },
    { value: 'Press magazine stylist', displayName: 'Press magazine stylist' }
];
export var countryChoices = [
    { value: 'All countries', displayName: 'All countries' },
    { value: 'Italy', displayName: 'Italy' },
    { value: 'India', displayName: 'India' },
    { value: 'China', displayName: 'China' },
    { value: 'Brazil', displayName: 'Brazil' },
    { value: 'Spain', displayName: 'Spain' },
    { value: 'United States', displayName: 'United States' },
    { value: 'South Korea', displayName: 'South Korea' },
    { value: 'France', displayName: 'France' },
    { value: 'Japan', displayName: 'Japan' },
    { value: 'United Kingdom', displayName: 'United Kingdom' },
    { value: 'Other', displayName: 'Other' }
];
export var forecastingSeasonsChoices = [
    { value: 'Fall-Winter 2026', displayName: 'Fall-Winter 2026' },
    { value: 'Spring-Summer 2026', displayName: 'Spring-Summer 2026' },
];
export var top20Choices = [
    {
        value: 'Top 20 Brands',
        displayName: 'Top 20 Brands'
    },
    {
        value: 'All Brands',
        displayName: 'All Brands'
    }
];
export var trendColorsMapping = {
    "Beige": "#d9b99b",
    "Black": "#4f4f4f",
    "Blue": "#2b87cd",
    "Brown": "#8f5945",
    "Burgundy": "#800020",
    "Camel": "#ac885f",
    "Cobalt": "#0047AB",
    "Cognac": "#9A463D",
    "Copper": "#b87333",
    "Cream": "#f5ea95",
    "Earthy tones": "#bd806d",
    "Fluo": "#5fff40",
    "Fuchsia": "#c154c1",
    "Gold": "#ffeb0b",
    "Green": "#177245",
    "Grey": "#8b8680",
    "Ivory": "#cdcdc1",
    "Khaki": "#819040",
    "Light blue": "#b2dfee",
    "Light green": "#9bda85",
    "Light grey": "#cfcfcf",
    "Light pink": "#ffb6c1",
    "Light yellow": "#ffec8b",
    "Lilac": "#c7a2c7",
    "Lime": "#32cd32",
    "Mustard": "#e1ad01",
    "Navy blue": "#0000b0",
    "Neutral tones": "#8b795e",
    "Orange": "#eb840f",
    "Pastel": "#f4cbdb",
    "Pink": "#ee799f",
    "Prune": "#981e5f",
    "Purple": "#7d26cd",
    "Red": "#ee0000",
    "Rust": "#b7410e",
    "Silver": "#c0c0c0",
    "Taupe": "#7a6555",
    "White": "#dbd7d2",
    "Yellow": "#ffe135"
};
